import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IKpiPreset } from 'app/shared/model/kpi-preset.model';
import { IKpiPresetWeight } from './kpi-preset-weight.model';

export interface IKpiPresetWeightVehicle {
  id?: number;
  activated?: boolean | null;
  kpiPresetWeight?: IKpiPresetWeight | null;
  truckImplement?: {
    id: number;
    licensePlate?: string;
  } | null;
}

export const defaultValue: Readonly<IKpiPresetWeightVehicle> = {
  activated: false,
};
